import { AVideoType, type AVideoProps } from '../atoms/AVideo/AVideo.types';

export type BrightcoveVideoProps = Extract<AVideoProps, { videoType: AVideoType.Brightcove }>;

export const isBrightcove = (video: AVideoProps): video is BrightcoveVideoProps =>
  video.videoType === AVideoType.Brightcove;

export const hasVideoCredentials = (video: AVideoProps): boolean =>
  isBrightcove(video) && Boolean(video.videoId) && Boolean(video.videoAccountId);
